<template>
  <sf-icon-button
    id="comparison-button"
    :color="inComparison(product.productId) ? 'green' : 'primary'"
    :icon="mdiSwapHorizontalBold"
    :aria-label="$t('addProductToComparison')"
    @click.prevent="inComparison(product.productId) ? removeFromComparison() : addToComparison()"
  />
</template>

<script setup lang="ts">
import SfIconButton from '@/components/button/SfIconButton.vue'
import useProductComparison from '@/modules/product/useProductComparison'
import { Event } from '@/modules/tracking/types'
import { trackEvent } from '@/modules/tracking/useTracking'
import { BundleItemProduct, MediumProduct, ShortProduct } from '@/types/index'
import { mdiSwapHorizontalBold } from '@mdi/js'
import { storeToRefs } from 'pinia'
import { PropType } from 'vue'

const props = defineProps({
  product: {
    type: Object as PropType<BundleItemProduct | MediumProduct | ShortProduct>,
    required: true
  },
  addToComparisonEvent: {
    type: Object as PropType<Event>,
    default: undefined
  },
  removeFromComparisonEvent: {
    type: Object as PropType<Event>,
    default: undefined
  }
})

const { inComparison } = storeToRefs(useProductComparison())
const addToComparison = () => {
  useProductComparison().addProduct(props.product.productId, props.product.productType)
  if (props.addToComparisonEvent) {
    trackEvent(props.addToComparisonEvent)
  }
}
const removeFromComparison = () => {
  useProductComparison().removeProduct(props.product.productId)
  if (props.removeFromComparisonEvent) {
    trackEvent(props.removeFromComparisonEvent)
  }
}
</script>
